<template>
  <v-dialog v-model="modal" max-width="600">
    <v-card>
      <v-card-title> Génération d'un extrait </v-card-title>
      <v-card-text>
        <p>Vous allez générer un extrait des inscriptions au registre pour cette association.</p>
        <v-checkbox
          v-if="avecRegistre"
          v-model="params.winlogas"
          label="Données issues du registre papier"
          persistent-hint
          hint="Si vous sélectionnez cette option, les données issues du registre papier seront présentées sur l'extrait"
          data-testid="donnees-registre-papier"
          />
        <p v-if="juridiction">
          L'extrait que vous allez générer ne comporte pas les données exhaustives
          inscrites au registre. Pour plus de précisions, merci de bien vouloir vous
          rapprocher du registre des associations du {{ juridiction }}.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-generer-extrait" ref="non" color="primary" @click="generer" :loading="generation">
          Générer
        </v-btn>
        <v-btn data-testid="annuler-generer-extrait" @click="ferme" :disabled="generation">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeDialog from "@/mixins/makeDialog";
import { associationService } from "@/services";

export default {
  mixins: [makeDialog],
  props: {
    association: {
      type: [Number, String],
      required: false,
    },
    avecRegistre: {
      type: Boolean,
      default: false,
    },
    juridiction: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      generation: false,
      url: null,
      params: {
        conforme: false,
        winlogas: false,
      },
    };
  },
  beforeDestroy() {
    this.nettoyage();
  },
  methods: {
    nettoyage() {
      if (this.url != null) {
        window.URL.revokeObjectURL(this.url);
        this.url = null;
      }
    },
    generer() {
      this.generation = true;
      associationService
        .extrait(this.association, this.params)
        .then(response => {
          this.nettoyage();
          this.url = window.URL.createObjectURL(response);
          const newWindow = window.open(this.url, "_blank");
          newWindow.focus();
          this.ferme();
        })
        .finally(() => {
          this.generation = false;
        });
    },
  },
};
</script>
